import Vue from 'vue'
import VueI18n from 'vue-i18n'
import LanguageDE from '@/languages/de.js'
import LanguageEN from '@/languages/en.js'
import LanguageFR from '@/languages/fr.js'
import LanguageIT from '@/languages/it.js'
import LanguageES from '@/languages/es.js'

Vue.use(VueI18n)

const messages = {
  de: LanguageDE,
  en: LanguageEN,
  fr: LanguageFR,
  it: LanguageIT,
  es: LanguageES
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'en', // set locale
  messages // set locale messages
})
export { i18n }



// WEBPACK FOOTER //
// ./src/components/i18n.js